/**
 * Created by OLD on 31/08/2015.
 */
define('messagesAllView',[
  'module',
  'underscore',
  'marionette',
  'app',
  'settings',
  'dateUtils',
  'template!messagesAllTpl',  
  'stateMessages',
  'rolesMixin',
  'zoomPopover',
  'translatePopoverBehavior'
], function(
  module,
  _,
  Marionette,
  App,
  Settings,
  dateConverter,
  viewTpl,
  StateMessages,
  RolesMixin,
  ZoomPopoverBehavior,
  TranslatePopoverBehavior
) {
  'use strict';

  var MessagesGraphicalRequestAllInOneView =  Marionette.ItemView.extend({
    template: viewTpl,

    ui: {
      toolTip: '[data-toggle="tooltip"]',
      imageCells: '.js-image-cell',
      attachmentFiles: '.js-attachment-file'
    },

    behaviors: {
      ZoomPopover: {
        behaviorClass: ZoomPopoverBehavior,
        manualInit: true,
        container: '.message-container'
      },
      StateMessages: {
        behaviorClass: StateMessages
      },
      TranslatePopHover: {
        behaviorClass: TranslatePopoverBehavior,
        target: '.translation',
        languagesTo: [Settings.get('lang'), 'uk']
      }
    },

    serializeData: function() {
      var templateData = this.model.toJSON();

      templateData.time = dateConverter.toTimeFormatString(templateData.date);
      templateData.day = dateConverter.toDateFormatString(templateData.date);
      templateData.content = templateData.content || '';
      _.each(templateData.attachements, function(item) {
        if(item.fileLink) {
          var fileArr = item.fileLink.split('getfile/'),
              fileUID;

          fileArr = fileArr[1].split('?');
          fileUID = fileArr[0];

          item.fileLink = Settings.url('base', item.fileLink);
          item.vectorizedLink = Settings.url('x2pdf', 'vectorteam/preparefile', {logoUID: fileUID});       
        }
      });

      if (templateData.userPid && templateData.userPid.logo) {
        templateData.fileUrl = Settings.url('file', templateData.userPid.logo);
      } else {
        templateData.fileUrl = null;
      }

      templateData.vectorizator = Settings.get('cAccountRoles')[RolesMixin.VECTORIZATOR];
      return templateData;
    },

    onShow: function() {
      $.material.init();
      this.showAttachments();
      this.ui.toolTip.tooltip();
    },

    showAttachments: function() {
      var that = this,
          counter = 0,
          attachements = this.model.get('attachements');
      _.each(attachements, function(item, index) {
        var imageCell, attachmentFile;
        if(item.fileLink) {
          imageCell = that.ui.imageCells.filter('.js-' + index);
          attachmentFile = that.ui.attachmentFiles.filter('.js-' + index);
          $('<img/>').attr('src', Settings.url('base', item.fileLink)).load(function() {
            $(this).remove();
            imageCell.attr('data-link', Settings.url('base', item.fileLink));
            imageCell.css('background-image', 'url(' + Settings.url('base', item.fileLink) + ')');
            imageCell.show();
            that.triggerMethod('show:image:zoom:popover', item.fileLink, imageCell);
            counter++;
            that.checkAttCounter(attachements,counter);
          }).error(function() {
            counter++;
            that.checkAttCounter(attachements,counter);
            $(this).remove();
            attachmentFile.show();
          });
        }
      });
      if (attachements.length === 0){
        this.trigger('attachedViewShown');
      }
    },

    //trigger it only once for message when images have loaded
    checkAttCounter: function(attachements,counter) {
      var length = attachements.length;
      if (length === counter) {
        this.trigger('attachedViewShown');
      }
    },

    onBeforeDestroy: function() {
      this.ui.toolTip.tooltip('destroy');
    }
  });

  module.exports = MessagesGraphicalRequestAllInOneView;
});
